// Single customer summary card used in the search results grid.
// Click navigates to /customers/:id.

import { Link } from "react-router";

import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { LastEditedBy } from "@/components/LastEditedBy";
import { withFrom } from "@/lib/nav";

interface CustomerCardProps {
  customer: {
    id: string;
    slug: string;
    name: string;
    tier: number | null;
    status: string;
    recent_orders_count: number;
    updated_at?: string | null;
    updated_by?: string | null;
    agent_id?: string | null;
  };
  listKey?: string;
}

export function CustomerCard({ customer, listKey }: CustomerCardProps) {
  const tierVariant =
    customer.tier === 1 ? "default" :
    customer.tier === 2 ? "secondary" :
    "muted";

  const to = `/customers/${customer.id}`;

  return (
    <Link to={listKey ? withFrom(to, listKey) : to} className="block">
      <Card className="h-full transition-colors hover:bg-muted/40 hover:border-primary/40">
        <CardContent className="flex h-full flex-col gap-3 p-4">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0 flex-1">
              <h3 className="truncate text-base font-semibold">{customer.name}</h3>
              <p className="truncate font-mono text-xs text-muted-foreground">
                {customer.slug}
              </p>
            </div>
            {customer.tier != null && (
              <Badge variant={tierVariant}>Tier {customer.tier}</Badge>
            )}
          </div>

          <div className="mt-auto flex items-center justify-between text-xs">
            <Badge variant={customer.status === "active" ? "success" : "muted"}>
              {customer.status}
            </Badge>
            <span className="text-muted-foreground">
              {customer.recent_orders_count} order
              {customer.recent_orders_count === 1 ? "" : "s"}
            </span>
          </div>
          <div className="border-t pt-2">
            <LastEditedBy
              updated_at={customer.updated_at}
              updated_by={customer.updated_by}
              agent_id={customer.agent_id}
            />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
